import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";

const PDIRejectedDialog = ({ open, onClose, onSubmit, setDialogOpen }) => {
  const [rejectionReason, setRejectionReason] = useState("");

  const handleSubmit = () => {
    onSubmit(rejectionReason); // Pass the entered name back to the parent
    setRejectionReason(""); // Clear the input field
    setDialogOpen(false);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Enter Rejected Reason</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Reason"
          type="text"
          fullWidth
          multiline
          minRows={2}
          value={rejectionReason}
          onChange={(e) => setRejectionReason(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="error">
          Rejected
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PDIRejectedDialog;
